// client-web-appsuite/src/constants/card.js

let CARD = {
    IMAGE: 'CardImage',
    IMPORT: 'CardImport',
    MODEL: 'CardModel',
    PROMPT: 'CardPrompt',
    OPTIMIZE: 'CardOptimize',
    GENERATE_GEOMETRY: 'CardGenerateGeometry',
    GENERATE_TEXTURE: 'CardGenerateTexture',
    SELECT_ASSET: 'CardSelectAsset',
    SELECT_FLOW: 'CardSelectFlow',
    SELECT_TEXTURE: 'CardSelectTexture',
    WATERTIGHT: 'CardWatertight'
}

CARD = Object.freeze(CARD)

export default CARD